module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-management"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'User Management'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("User Management")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar User\n            "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.users,
      "headers": _vm.headers,
      "hasAction": true,
      "has-custom-pagination": true,
      "custom-pagination-per-page": 10,
      "custom-pagination-current-page": _vm.pageNumber
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": _vm.goToDetail,
      "changePage": function($event) {
        _vm.pageNumber = $event
      },
      "doSearch": function($event) {
        _vm.query = $event;
        _vm.loadUserData();
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a6bf1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/usman/components/UserManagement.vue
// module id = 2147
// module chunks = 1